import { getEnvironment, LOCAL, PRODUCTION } from '@atlassian/temp-shared';
import { SENTRY_DSN_FOR_PPC_UI } from '@css-xp/ppc-constants';
import { init, browserTracingIntegration, Event } from '@sentry/react';

const isFilteredEvent = (event: Event | undefined): boolean => {
  const frames = event?.exception?.values?.[0]?.stacktrace?.frames;
  if (!frames || frames.length === 0) return false;
  const firstFrame = frames[0];
  /*
   * disable errors originating from injected scripts
   * reference: https://github.com/getsentry/sentry-javascript/issues/3147
   */
  if (firstFrame.filename === '<anonymous>') {
    return true;
  } else if (
    firstFrame.filename?.includes('/partner-purchase-center/pages/cart/src/store/utils/get-bill-estimate.ts')
  ) {
    return true;
  }
  return false;
};

export const initSentryClient = () => {
  const env = getEnvironment();
  if (env !== LOCAL) {
    init({
      dsn: SENTRY_DSN_FOR_PPC_UI,
      integrations: [browserTracingIntegration()],
      tracesSampleRate: 1,
      debug: env !== PRODUCTION,
      environment: env,
      beforeSend: (event) => {
        if (isFilteredEvent(event)) {
          return null;
        }
        return event;
      },
      //NOTE: make sure to explicitly add the error message to the ignoreErrors list
      ignoreErrors: [
        'Non-Error exception captured', // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/14
        'Non-Error promise rejection captured',
        'Event `CustomEvent` (type=unhandledrejection) captured as promise rejection',
      ],
    });
  }
};
